<template>
  <div>
    <!-- TradingView Widget BEGIN -->
    <div class="tradingview-widget-container">
      <div id="tradingview_wr"></div>
      <div class="market-chart-copyright">
        <a href="https://ru.tradingview.com/" rel="noopener" target="_blank"
          >График от TradingView</a
        >
      </div>
    </div>
    <!-- TradingView Widget END -->
  </div>
</template>

<script>
import TradingView from '@/assets/tradingview'
import { mapState } from 'vuex'

export default {
  props: {
    symbol: String,
    interval: String,
  },
  methods: {
    recreateTW() {
      if (!this.TW) this.TW = TradingView // just for debug

      if (this.$store.state.market.ticker && this.mappedPlatform)
        this.canDownload = true
      if (!this.canDownload) return
      this.widget = new TradingView.widget({
        autosize: true,
        symbol: `${this.mappedPlatform}:${this.$store.state.market.ticker}`,
        interval: '15',
        timezone: 'Europe/Moscow',
        theme: this.$store.state.layout.themeBlack ? 'dark' : 'light',
        style: '1',
        locale: 'ru',
        toolbar_bg: '#f1f3f6',
        enable_publishing: false,
        save_image: false,
        container_id: 'tradingview_wr',
      })
    },
  },
  mounted() {
    this.recreateTW()
  },
  watch: {
    changableValues() {
      this.recreateTW()
    },
  },
  computed: {
    ...mapState('layout', {
      theme: (state) => (state.themeBlack ? 'dark' : 'light'),
    }),
    ...mapState('market', {
      ticker: (state) => state.ticker,
      mappedPlatform: (state) => {
        const p = state.platform

        if (p === 'LSE') return 'LSIN'
        if (p === 'EPA') return 'EURONEXT'
        return p
      },
    }),
    changableValues() {
      return `${this.theme}|${this.mappedPlatform}|${this.ticker}`
    },
  },
  data() {
    return {
      canDownload: false,
    }
  },
}
</script>

<style lang="scss">
.tradingview-widget-container {
  position: relative;

  > #tradingview_wr {
    height: 400px;
  }
  > .market-chart-copyright {
    bottom: -0.2rem !important;
  }
}
</style>
